import {
  CONDO_INSERT,
  CONDO_INSERT_FAIL,
  CONDO_INSERT_SUCCESS,
  CONDO_SEARCH,
  CONDO_SEARCH_FAIL,
  CONDO_SEARCH_SUCCESS,
  CONDO_SELECT,
  CONDO_SELECT_FAIL,
  CONDO_SELECT_SUCCESS,
  CONDO_UPDATE,
  CONDO_UPDATE_FAIL,
  CONDO_UPDATE_SUCCESS,
  HOME_BUTTON_CLICKED,
} from '../../constants/ActionTypes';

const initialState = {
  condoSearchResults: null,
  condoSelected: null, // unused for now
  isLoading: false,
  isSearching: false,
  updateStatus: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONDO_INSERT:
    case CONDO_SELECT:
    case CONDO_UPDATE:
      return {
        ...state,
        isLoading: true,
      };
    case CONDO_SEARCH:
      return {
        ...state,
        isSearching: true,
      };
    case CONDO_INSERT_FAIL:
    case CONDO_SELECT_FAIL:
    case CONDO_UPDATE_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    case CONDO_SEARCH_FAIL:
      return {
        ...state,
        isSearching: false,
      };
    case CONDO_INSERT_SUCCESS: {
      return {
        ...state,
        condoSearchResults: [...state.condoSearchResults, action.payload.newCondo],
        isLoading: false,
      };
    }
    case CONDO_SEARCH_SUCCESS:
      return {
        ...state,
        condoSearchResults: action.payload.condoSearchResults,
        isSearching: false,
      };
    case CONDO_SELECT_SUCCESS:
      return {
        ...state,
        condoSelected: action.payload.condoSelected,
        isLoading: false,
      };
    case CONDO_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateStatus: action.payload.updateStatus,
      };
    case HOME_BUTTON_CLICKED:
      return initialState;
    default:
      return state;
  }
};
